import { useState } from 'react';

const useDisplayImage = () => {
  const [result, setResult] = useState('');

  function uploader(e) {
    const imageFile = e.target.files[0];

    const reader = new FileReader();
    reader.addEventListener('load', (e) => {
      setResult({ ...result, src: e.target.result, name: imageFile.name });
    });

    reader.readAsDataURL(imageFile);
  }

  return { result, uploader };
};

export default useDisplayImage;
